// extracted by mini-css-extract-plugin
export default {"container_alert":"alert_container_alert__CRn6T","active":"alert_active__fqXyV"};